import { Lang } from "../i18n/translations";

/** Pick FR field or EN fallback (fieldEn). */
export function pickLocalized(item: Record<string, any> | null | undefined, field: string, lang: Lang): string {
  if (!item) return "";
  if (lang === "en") {
    const en = item[`${field}En`];
    if (en) return en;
  }
  return item[field] ?? "";
}

export function stripHtml(html: string): string {
  if (!html) return "";
  return html.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
}
